import ActionTypes from './types'
import {loadChatRoomsByBuilding, loadConversationsByBuilding} from '../lib/queries'
import {CACHE_ActiveBuildingId} from '../constants/AppConstants'

/**
 * @param {Dispatch} dispatch
 * @param {string} filterStr
 */
export const setMessagesFilterString = (dispatch, filterStr) => {
  dispatch({
    type: ActionTypes.MESSAGES_UPDATE_FILTER_ACTION,
    payload: filterStr,
  })
}

/**
 * @param {Dispatch} dispatch
 * @param {string }buildingId
 * @return {Promise<Array<*>>}
 */
export async function loadConversations(dispatch, buildingId) {
  let conversations = await loadConversationsByBuilding(buildingId)

  let filteredConversations = conversations.filter(
    conversation => conversation.resident && !conversation.resident.isDeleted && conversation.resident.statusOverride !== 'Past',
  )

  let chatRooms = await loadChatRoomsByBuilding(buildingId)

  // if we changed buildings between requests, we don't want to update the state
  if (buildingId !== localStorage[CACHE_ActiveBuildingId]) {
    return []
  }

  dispatch({
    type: ActionTypes.MESSAGES_SYNC_CONVERSATIONS,
    conversations: filteredConversations,
    chatRooms: chatRooms,
  })

  // Note: we just return conversations because the only thing that cares about this function's return value
  // only cares about conversations. if we want to start processing chatRooms as well, we can refactor
  return filteredConversations
}

/**
 * @param {Dispatch} dispatch
 * @param {GenericChatMessage} newMessage
 * @return {Promise<*>}
 */
export async function sendNewMessage(dispatch, newMessage) {
  dispatch({
    type: ActionTypes.MESSAGES_CREATED_NEW_MESSAGE,
    payload: newMessage,
  })

  return newMessage
}

/**
 * @param {Dispatch} dispatch
 * @param {string} conversationId
 * @param {string?} message
 */
export function saveDraftMessage(dispatch, conversationId, message) {
  dispatch({
    type: ActionTypes.MESSAGES_SET_DRAFT_MESSAGE,
    conversationId: conversationId,
    message: message,
  })
}
